import React from 'react';
import Header from '@components/mobile-header';
import Footer from '@components/footer';
import Content from './component';

const IDActivity = () => {
    return (
        <div className="id-activity-container">
            <Header />
            <Content />
            <Footer />
        </div>
    );
};

export default IDActivity;
